module.exports = __webpack_public_path__ + "static/media/astar_step_0.ffb53751.png";